import type { QuizListItem } from '../hooks/useQuizzesListView'

export const selectFeaturedQuiz = (
  items: QuizListItem[]
): QuizListItem | null => items.find(item => item.featured) ?? null
